/**
 * Shared account-type constants and helpers.
 * Keep frontend and mobile lists aligned with each other.
 */

/** Politician UI: profile display, community guidelines, verification flows. */
export const POLITICIAN_ACCOUNT_TYPES = [
  "local_politician",
  "state_politician",
  "federal_politician",
  "public_official_candidate",
];

/** Elected office holders only (excludes candidates). */
export const POLITICIAN_OFFICE_ACCOUNT_TYPES = [
  "local_politician",
  "state_politician",
  "federal_politician",
];

/** Candidate account types (includes legacy `candidate`). */
export const CANDIDATE_ACCOUNT_TYPES = [
  "candidate",
  "public_official_candidate",
];

/** Politician + candidate — onboarding / final-setup welcome flow. */
export const POLITICIAN_SETUP_ACCOUNT_TYPES = [
  "public_official_candidate",
  "state_politician",
  "federal_politician",
  "local_politician",
  "candidate",
];

export function isPoliticianAccount(accountTypeName) {
  const normalized = (accountTypeName || "").toLowerCase();
  return POLITICIAN_ACCOUNT_TYPES.includes(normalized);
}

export function isPoliticianOfficeAccount(accountTypeName) {
  const normalized = (accountTypeName || "").toLowerCase();
  return POLITICIAN_OFFICE_ACCOUNT_TYPES.includes(normalized);
}

export function isCandidateAccount(accountTypeName) {
  const normalized = (accountTypeName || "").toLowerCase();
  return CANDIDATE_ACCOUNT_TYPES.includes(normalized);
}

export function isPoliticianSetupAccount(accountTypeName) {
  return POLITICIAN_SETUP_ACCOUNT_TYPES.includes((accountTypeName || "").toLowerCase());
}

/**
 * Account types that may hide their name on community posts and comments.
 * Mirrors ANONYMOUS_ELIGIBLE_ACCOUNT_TYPES in backend/census_data/post_writes.py;
 * `user` is the legacy citizen type.
 */
export const ANONYMOUS_ELIGIBLE_ACCOUNT_TYPES = ["citizen", "user"];

export function canPostAnonymously(accountTypeName) {
  return ANONYMOUS_ELIGIBLE_ACCOUNT_TYPES.includes((accountTypeName || "").toLowerCase());
}

/** True when the viewer can log an action on this post via /actions/. */
export function canLogPostAction(post) {
  return Boolean(post?.action_type);
}
